export default __webpack_public_path__ + "static/media/i023vp.4c0a48f3.webp";